import {
  GetCollaboratorCmSheetCareerPathResponse,
  UpdateCollaboratorCmSheetCareerPathRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetCareerPathService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCollaboratorCmSheetCareerPathResponse> {
    const response =
      await httpClient.get<GetCollaboratorCmSheetCareerPathResponse>(
        `v1/cm-sheets/${cmSheetId}/career-path`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorCmSheetCareerPathRequest,
  ): Promise<void> {
    await httpClient.put(`v1/cm-sheets/${cmSheetId}/career-path`, body);
  },
};

export default CmSheetCareerPathService;
